<template>
  <div>
    <div class="account--padding">
      <div class="row">
        <input-text
            class="col-6 mb-3 pr-2"
            :title="$t('myAccount.firstName')"
            :data="v$.addressData.first_name"
            :error-text='$t("myAccount.errorFirstName")'
            name="first_name"
            :maxlength="32"
            id="input_first_name"
            v-model="addressData.first_name"
        />

        <input-text
            class="col-6 mb-3 pl-2"
            :maxlength="32"
            :title='$t("myAccount.lastName")'
            :data="v$.addressData.last_name"
            :error-text='$t("myAccount.errorLastName")'
            name="last_name"
            id="input_last_name"
            v-model="addressData.last_name"
        />

        <input-text
            :class="parseInt(addressData.id_country) !== countriesData.ID_COUNTRY_FRANCE ? 'col-9 pr-2' : 'col-12'"
            :title='$t("myAccount.address")'
            :maxlength="32"
            :data="v$.addressData.address"
            :error-text='$t("myAccount.errorAddress")'
            :placeholder="$t('address.placeholderAddress')"
            name="address"
            id="input_address"
            class="mb-3"
            v-model="addressData.address"
        />

        <input-text
            v-if="parseInt(addressData.id_country) !== countriesData.ID_COUNTRY_FRANCE"
            class="col-3 mb-3 pl-2"
            :maxlength="5"
            :data="v$.addressData.house_number"
            :error-text='$t("myAccount.errorHouseNumber")'
            placeholder="123 b"
            name="house_number"
            id="input_house_number"
            v-model="addressData.house_number"
        />

        <!-- Address 2 : BE, FR, DE, AT, IT -->
        <input-text
            v-if="addressTwoField.includes(parseInt(addressData.id_country))"
            class="col-12 mb-3"
            :title='$t("myAccount.address2")'
            :maxlength="32"
            :data="v$.addressData.address2"
            :error-text='$t("myAccount.errorAddress2")'
            :placeholder="$t('address.placeholderAddress2')"
            :optional='$t("myAccount.optional")'
            name="address"
            id="input_address"
            v-model="addressData.address2"
        />

        <input-text
            class="col-5 mb-2 pr-2"
            :title='$t("myAccount.zipcode")'
            :data="v$.addressData.postcode"
            :error-text='$t("myAccount.errorZipcode")'
            :placeholder="addressData.id_country === 19 ? '1234' : $t('address.placeholderZipcode')"
            name="city"
            :maxlength="6"
            id="input_city"
            v-model="addressData.postcode"
        />

        <input-text
            class="col-7 mb-2 pl-2"
            :title='$t("myAccount.residence")'
            :data="v$.addressData.city"
            :error-text='$t("myAccount.errorCity")'
            :placeholder="addressData.id_country === 19 ? 'Bern' : $t('address.placeholderCity')"
            name="city"
            :maxlength="32"
            id="input_city"
            v-model="addressData.city"
        />

          <div
              class="col-12 mb-2"
              v-show="addressData.id_country === countriesData.ID_COUNTRY_NETHERLANDS ||
                      addressData.id_country === countriesData.ID_COUNTRY_FRANCE ||
                      addressData.id_country === countriesData.ID_COUNTRY_LUXEMBOURG"
          >
              <div>{{ $t("myAccount.country") }}</div>
              <select
                  name="country"
                  id="input_country_addressCreate"
                  v-model="addressData.id_country"
                  class="input-select--country"
                  v-on:change="checkCountry()"
              >
                  <option
                      v-for="country in countries"
                      :value="country.id_country"
                  >{{ country.name }}
                  </option>
              </select>
          </div>

        <input-text
            class="col-12"
            :title='$t("myAccount.phoneNumber")'
            :data="v$.addressData.phone"
            :error-text='$t("myAccount.errorPhone")'
            :sub-text='$t("myAccount.phoneNumberMessage")'
            :placeholder='$t("address.placeholderPhone")'
            :maxlength="32"
            name="phone"
            id="input_phone"
            v-model="addressData.phone"
        />

        <div v-if="errorBag.length" class="col-12 mt-3 text--sm">
          <i class="fas fa-times-circle text-danger mr-2"></i>
          {{ $t("myAccount.errorMessage") }}
          <div v-for="error in errorBag">
            <div class="text-danger ml-4" v-text="'- '+ getValidationError(error.name, error.type)"></div>
          </div>
        </div>
      </div>

        <div class="row">
            <div class="col-12 account__card--bottom-bar align-items-center py-4">
                <div class="button button--clear m-0" @click="cancelEdit()">{{ $t("myAccount.cancel") }}</div>
                <div
                    class="button-brekz button-brekz--rounded button-brekz--lg m-0 text-center"
                    :class="{'button-brekz--green': !isSubmitting}"
                    @click="submitForm(address.id_address)"
                >
                    <img
                        v-if="isSubmitting"
                        class="mx-auto"
                        style="height: 25px;"
                        src="/themes/brekz-2017/img/loading-indicator-l.gif"
                    >
                    <div v-else>{{ $t("myAccount.save") }}</div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import validationRules from '../../js/validation/rules';
import InputText from "../Address/InputText";
import getError from '../../js/validation/getError';
import axios from "axios";

import useVuelidate from "@vuelidate/core";
import { maxLength, required, requiredIf } from '@vuelidate/validators'

const ID_COUNTRY_GERMANY     = 1;
const ID_COUNTRY_AUSTRIA     = 2;
const ID_COUNTRY_BELGIUM     = 3;
const ID_COUNTRY_FRANCE      = 8;
const ID_COUNTRY_ITALY       = 10;
const ID_COUNTRY_LUXEMBOURG  = 12;
const ID_COUNTRY_NETHERLANDS = 13;
const ID_COUNTRY_SWITZERLAND = 19;
const ID_COUNTRY_DENMARK     = 20;

const addressTwoField = [
    ID_COUNTRY_NETHERLANDS,
    ID_COUNTRY_GERMANY,
    ID_COUNTRY_AUSTRIA,
    ID_COUNTRY_SWITZERLAND,
    ID_COUNTRY_FRANCE,
    ID_COUNTRY_ITALY,
    ID_COUNTRY_BELGIUM,
    ID_COUNTRY_DENMARK,
];


export default {
  name: "CheckoutAddressEdit",
  props: {
    address: Object,
    countries: Array,
    defaultCountryId: Number,
    getAddressLink: {
        required: false,
        type: String,
    },
  },
  components: {
    InputText,
  },
  setup () {
      return { v$: useVuelidate() }
  },
  data() {
    return {
      addressData: {
        id_address: 0,
        first_name: '',
        last_name: '',
        address: '',
        house_number: '',
        address2: '',
        postcode: '',
        city: '',
        country: this.defaultCountry,
        id_country: this.defaultCountry,
        phone: ''
      },
      countriesData: {
        ID_COUNTRY_GERMANY: ID_COUNTRY_GERMANY,
        ID_COUNTRY_AUSTRIA: ID_COUNTRY_AUSTRIA,
        ID_COUNTRY_BELGIUM: ID_COUNTRY_BELGIUM,
        ID_COUNTRY_FRANCE: ID_COUNTRY_FRANCE,
        ID_COUNTRY_ITALY: ID_COUNTRY_ITALY,
        ID_COUNTRY_LUXEMBOURG: ID_COUNTRY_LUXEMBOURG,
        ID_COUNTRY_NETHERLANDS: ID_COUNTRY_NETHERLANDS,
        ID_COUNTRY_DENMARK: ID_COUNTRY_DENMARK,
      },
      addressTwoField: addressTwoField,
      isSubmitting: false,
    };
  },
  validations: {
      addressData: {
          first_name: {
              required,
              maxlength: maxLength(32),
          },
          last_name: {
              required,
              maxlength: maxLength(32),
          },
          address: {
              required,
              validateAddress: validationRules.address,
              maxlength: maxLength(32),
          },
          house_number: {
              required: requiredIf(function (){
                  return this.addressData.id_country !== this.countriesData.ID_COUNTRY_FRANCE
              }),
              maxlength: maxLength(5),
              validateHouseNumber: validationRules.houseNumber,
          },
          address2: {
              maxlength: maxLength(128),
          },
          postcode: {
              required,
              validateZipCode: validationRules.zipCode
          },
          city: {
              required,
              validateCity: validationRules.city
          },
          phone: {
              validatePhone: validationRules.phone
          },
      }
  },
  computed: {
      errorBag() {
          if (!this.v$.addressData) {
              return [];
          }

          return this.v$
                     .addressData
                     .$errors
                     .map((error) => ({
                         name: error.$property,
                         type: error.$validator,
                         error: error.$message
                     }));
      },
      passesValidation() {
          return (
              this.errorBag.length === 0
          );
      }
  },
  mounted() {
    this.addressData = this.mapAddressProp(this.address);
  },
    watch: {
        address: {
            immediate: true,
            deep: true,
            handler(newAddress) {
                this.addressData = this.mapAddressProp(newAddress);
            }
        },
        passesValidation: {
            immediate: true,
            handler(passed) {
                this.$emit("passes-validation-changed", passed);
            }
        }
    },
  methods: {
    mapAddressProp(address) {
      return {
        id_address: address.id_address,
        first_name: address.firstname,
        last_name: address.lastname,
        address: address.address1,
        house_number: address.house_number,
        address2: address.address2,
        postcode: address.postcode,
        city: address.city,
        country: parseInt(address.id_country),
        id_country: parseInt(address.id_country),
        phone: address.phone
      };
    },
    getValidationError(name, type) {
      return getError(name, type);
    },
    checkCountry() {
      if ($('#input_country_addressEdit').val() === '13') {
        $('#input_zipcode_addressEdit').attr('placeholder', '1234AB').focus().blur();
      }
      if ($('#input_country_addressEdit').val() === '3') {
        $('#input_zipcode_addressEdit').attr('placeholder', '1234').focus().blur();
      }

    },
    countryIdToIsoCode(country_id) {
      for(var i = 0; i < this.countries.length; i++) {
        if (parseInt(this.countries[i].id_country) === parseInt(country_id)) {
          return this.countries[i].iso_code;
        }
      }

      return false;
    },
    checkInput(inputName) {
      for(let i = 0; i < this.errorBag.length; i++) {
        if (this.errorBag[i].fieldName === inputName) {
          return true;
        }
      }

      return false;
    },
    submitForm(id_address) {
          this.v$.$touch();

          if (this.v$.$invalid) {
              return;
          }

          this.isSubmitting         = true;
          this.addressData.postcode = this.addressData.postcode.replace(' ', '');

          axios.put(`${this.getAddressLink}?action=update`, JSON.stringify(this.addressData))
               .then(response => {
                   this.$emit('address-updated', this.addressData.id_address);

                   this.isSubmitting = false;
               })
               .catch((error) => {
                   this.$emit('error-occurred');
                   console.log('Update address failed', error);
                   this.isSubmitting = false;
               });

    },

    cancelEdit() {
      this.$emit("cancel-edit");
    }
  }
};
</script>
